import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

const formatRatio = descriptor => {
  if (!descriptor) {
    return '-';
  }
  const decimal = descriptor.ratio.toFixed(3);
  return descriptor.label ? `${descriptor.label} (${decimal})` : decimal;
};

const Row = ({ label, size, descriptor }) => (
  <div tw="flex items-baseline justify-between gap-3 leading-none">
    <span tw="text-[9px] uppercase tracking-[0.08em] text-white/45">{label}</span>
    <span tw="text-[11px] font-[700] text-white/90 tabular-nums">
      {size} · {formatRatio(descriptor)}
    </span>
  </div>
);

// Aspect-ratio readout for the media MediaPipe is reading from — the live camera
// or an uploaded clip. Bottom-left corner: the score/FPS bar owns bottom-center
// and the hold telemetry owns bottom-right, so nothing overlaps.
const AspectRatioOverlay = ({ geometry, mediaSourceType, isStackedMobile = false }) => {
  const { t } = useTranslation('exercise');

  if (!geometry) {
    return null;
  }

  const sourceLabel =
    mediaSourceType === 'upload'
      ? t('aspectRatioOverlay.uploadedVideo')
      : t('aspectRatioOverlay.camera');

  return (
    <div
      // Same z band as the hold telemetry: above the video/canvas/border layers,
      // below the modals (9999). Non-interactive so it never eats a tap.
      tw="pointer-events-none fixed z-[9000] w-[188px] rounded-[10px] border border-white/15 bg-black/60 px-2.5 py-2 font-mono backdrop-blur-[3px] shadow-[0_6px_18px_rgba(0,0,0,0.35)]"
      css={isStackedMobile ? tw`bottom-24 left-3` : tw`bottom-4 left-4`}
    >
      <div tw="mb-1.5 flex items-center gap-1.5 border-b border-white/10 pb-1.5">
        <span tw="h-1.5 w-1.5 shrink-0 rounded-full bg-[#38BDF8]" />
        <span tw="text-[10px] font-[700] uppercase tracking-[0.1em] text-white/70">
          {sourceLabel}
        </span>
      </div>
      <div tw="grid gap-1">
        <Row
          label={t('aspectRatioOverlay.source')}
          size={`${geometry.width}×${geometry.height}`}
          descriptor={geometry.source}
        />
        <Row
          label={t('aspectRatioOverlay.display')}
          size={`${geometry.displayWidth}×${geometry.displayHeight}`}
          descriptor={geometry.display}
        />
      </div>
    </div>
  );
};

export default AspectRatioOverlay;
